document.addEventListener('DOMContentLoaded', function () {
  try {
    const auditor = document.querySelector('input[type="checkbox"][id$="_is_auditor"]');
    const admins = document.querySelectorAll(
      'input[type="checkbox"][id$="_is_organization_admin"], ' +
      'input[type="checkbox"][id$="_is_location_admin"], ' +
      'input[type="checkbox"][id$="_is_enterprise_training_admin"]'
    );
    const productCoordinator = document.querySelector('input[type="checkbox"][id$="_is_product_coordinator"]');

    if (!auditor) {
      return;
    }
    if (admins.length === 0 && !productCoordinator) {
      return;
    }

    function toggleRoles() {
      const anyAdminChecked = Array.from(admins).some(cb => cb.checked);

      if (auditor.checked) {
        admins.forEach(cb => {
          cb.checked = false;
          cb.disabled = true;
          const label = cb.closest('label');
          if (label) label.classList.add('text-muted');
        });
        if (productCoordinator) {
          productCoordinator.checked = false;
          productCoordinator.disabled = true;
          const label = productCoordinator.closest('label');
          if (label) label.classList.add('text-muted');
        }
      } else {
        admins.forEach(cb => {
          cb.disabled = false;
          const label = cb.closest('label');
          if (label) label.classList.remove('text-muted');
        });
        if (productCoordinator) {
          productCoordinator.disabled = false;
          const label = productCoordinator.closest('label');
          if (label) label.classList.remove('text-muted');
        }
      }

      if (anyAdminChecked || (productCoordinator && productCoordinator.checked)) {
        auditor.checked = false;
        auditor.disabled = true;
        const label = auditor.closest('label');
        if (label) label.classList.add('text-muted');
      } else {
        auditor.disabled = false;
        const label = auditor.closest('label');
        if (label) label.classList.remove('text-muted');
      }
    }

    auditor.addEventListener('change', toggleRoles);
    admins.forEach(cb => cb.addEventListener('change', toggleRoles));
    if (productCoordinator) {
      productCoordinator.addEventListener('change', toggleRoles);
    }

    toggleRoles();
  } catch (err) {
  }
});
